/*
 * IMPORTS
 */
import { gql } from "@apollo/client"; // NPM: Apollo client for handling graphql request.

/*
 * GRAPH
 */
const Index = gql`
  query MyQuery {
    DashBoardBrandName {
      message
      status
      id
      brandName
      duration
    }
  }
`;

/*
 * EXPORTS
 */
export default Index;
